/**
 * Monthlyized price for multi-period plans; null for monthly or invalid.
 * @param {number} price
 * @param {number} periods
 * @returns {number|null}
 */
const getMonthlyEquivalent = (price, periods) => {
  if (
    typeof price !== "number" ||
    Number.isNaN(price) ||
    typeof periods !== "number" ||
    Number.isNaN(periods) ||
    periods <= 1
  ) {
    return null;
  }

  return price / periods;
};

export default getMonthlyEquivalent;
